import React, { useState } from "react";
import PackageCard from "../utilities/PackageCard";

const SubscriptionPackages = ({ packages }) => {
  const [selectedDuration, setSelectedDuration] = useState("1 month");
  
  const durations = ["1 month", "2 months", "3 months", "No Expiry"];

  const sortPackages = (packages) => {
    const order = ["Bronze", "Silver", "Gold", "Platinum"];
    return packages.sort((a, b) => {
      return order.indexOf(a.name) - order.indexOf(b.name);
    });
  };

  const sortedPackages = packages ? sortPackages([...packages]) : [];

  // Get the details for the selected duration
  const getPackageDetails = (pkg) => {
    const detail = pkg.details?.find(
      (d) => d.name === selectedDuration
    );
    return detail || pkg.details?.[0] || {};
  };

  return (
    <section id="pricing" className="py-16 bg-gray-50">
      <div className="container px-4 mx-auto">
        <div className="mb-12 text-center">
          <h2 className="mb-4 text-3xl font-bold text-gray-800 md:text-4xl">
            Choose Your Plan
          </h2>
          <p className="mx-auto max-w-2xl text-gray-600">
            We offer a variety of packages to meet your SMS needs. Select the
            plan that works best for you and start connecting with your audience
            today.
          </p>

          {/* Duration Selector */}
          <div className="flex justify-center mt-8">
            <div className="inline-flex gap-2 p-2 bg-white rounded-full shadow-lg">
              {durations.map((duration) => (
                <button
                  key={duration}
                  onClick={() => setSelectedDuration(duration)}
                  className={`px-6 py-3 rounded-full font-semibold transition-all duration-300 ${
                    selectedDuration === duration
                      ? "bg-red-600 text-white shadow-md"
                      : "text-gray-700 hover:bg-gray-100"
                  }`}
                >
                  {duration === "1 month" && "1 Month"}
                  {duration === "2 months" && "2 Months"}
                  {duration === "3 months" && "3 Months"}
                  {duration === "No Expiry" && "No Expiry"}
                </button>
              ))}
            </div>
          </div>
        </div>

        <div className="grid grid-cols-1 gap-8 mx-auto max-w-8xl md:grid-cols-2 lg:grid-cols-4">
          {sortedPackages.map((pkg) => {
            const details = getPackageDetails(pkg);
            return (
              <PackageCard
                key={pkg.id}
                name={pkg.name}
                unit={details.unit}
                price={details.price}
                packageId={pkg.id}
                duration={selectedDuration}
                isPopular={pkg.name === "Silver"}
              />
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default SubscriptionPackages;